import React from 'react';
import { arrayOf, bool, func, object, oneOf, shape, string } from 'prop-types';

import EsmsDialog from '../../components/EsmsDialog';

import { getErrorMessage } from '../../helpers/errors';

import classes from './DeviceModificationResultModal.module.css';

const ActionTitles = {
    create: 'Creation',
    delete: 'Deletion'
};
const ResultTitles = {
    create: 'created',
    delete: 'deleted'
};

const DeviceModificationResultModal = ({
    errors,
    modificationType,
    onClose,
    open
}) => (
    <EsmsDialog
        cancelable={false}
        confirmText="OK"
        imgSrc="/assets/images/devicesIconColor.svg"
        open={open}
        onClose={onClose}
        onConfirm={onClose}
        title={`Device ${ResultTitles[modificationType]} with errors`}
    >
        <p>
            Uh oh, it looks like a few of your Devices could not be {ActionTitles[modificationType]}!
        </p>
        <p>
            The following items failed during Device {ActionTitles[modificationType]}:
        </p>
        <ul className={classes.errors}>
            {errors.map(({ item, error }, key) => (
                <li key={key}>
                    {item.name}: {getErrorMessage(error)}
                </li>
            ))}
        </ul>
        <p>
            Please use the Devices and Objects table to manage your Devices.
        </p>
        <p>
            <a
                href="https://docs.key2act.io/"
                rel="noopener noreferrer"
                target="_blank"
            >
                Why did my items fail Device creation?
            </a>
        </p>
    </EsmsDialog>
);


DeviceModificationResultModal.defaultProps = {
    errors:           [],
    onClose:          () => {},
    open:             false,
    modificationType: oneOf(Object.keys(ActionTitles))
};

DeviceModificationResultModal.propTypes = {
    errors: arrayOf(shape({
        item: shape({
            name: string.isRequired
        }).isRequired,
        error: object.isRequired
    })),
    onClose: func,
    open:    bool
};

export default DeviceModificationResultModal;
